import { createIcon } from '../shared'

const BookmarkIcon = createIcon(
  ({ color }) => (
    <path
      d="M4 4.5C4 3.12 5.119 2 6.5 2H17.5C18.881 2 20 3.12 20 4.5V22.94L12 17.23L4 22.94V4.5ZM6.5 4C6.224 4 6 4.22 6 4.5V19.06L12 14.77L18 19.06V4.5C18 4.22 17.776 4 17.5 4H6.5Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'TwitterBookmarkIcon',
)

export { BookmarkIcon }
